import cssDefs from "~src/models/properties.json";

export const styleProps = Object.keys(cssDefs);
export { cssDefs };

export interface StyleDefinition {
    name: string;
    syntax: string;
    groups: string[];
    mdnUrl: string;
}

export const styleDefs: StyleDefinition[] = Object.keys(cssDefs).map((theStyle) => {
    const rawStyleObject = cssDefs[theStyle];
    const styleDef: StyleDefinition =
        {
            name: theStyle,
            syntax: rawStyleObject.syntax,
            groups: rawStyleObject.groups,
            mdnUrl: rawStyleObject["mdn_url"]
        };
    return styleDef;
});

export const cssGroups = [
    //"Basic Selectors",
    //"Combinators",
    "Compositing and Blending",
    //"CSS Angles",
    "CSS Animations",
    "CSS Backgrounds and Borders",
    "CSS Basic User Interface",
    "CSS Box Model",
    "CSS Box Alignment",
    //"CSS Break",
    //"CSS Cascading and Inheritance",
    //"CSS Charsets",
    "CSS Color",
    "CSS Columns",
    //"CSS Conditional Rules",
    "CSS Containment",
    "CSS Counter Styles",
    //"CSS Device Adaptation",
    "CSS Display",
    "CSS Flexible Box Layout",
    //"CSS Flexible Lengths",
    "CSS Fonts",
    "CSS Fragmentation",
    //"CSS Frequencies",
    "CSS Generated Content",
    "CSS Grid Layout",
    //"CSS Houdini",
    "CSS Images",
    "CSS Inline",
    //"CSS Lengths",
    "CSS Lists and Counters",
    "CSS Logical Properties",
    "CSS Masking",
    "CSS Miscellaneous",
    "CSS Motion Path",
    //"CSS Namespaces",
    "CSS Overflow",
    "CSS Pages",
    "CSS Positioning",
    //"CSS Regions",
    //"CSS Resolutions",
    "CSS Ruby",
    "CSS Scroll Anchoring",
    "CSS Scrollbars",
    "CSS Scroll Snap",
    //"CSS Shadow Parts",
    "CSS Shapes",
    "CSS Speech",
    "CSS Table",
    "CSS Text",
    "CSS Text Decoration",
    //"CSS Times",
    "CSS Transforms",
    "CSS Transitions",
    //"CSS Types",
    //"CSS Units",
    //"CSS Variables",
    "CSS Will Change",
    "CSS Writing Modes",
    "CSSOM View",
    "Filter Effects",
    //"Grouping Selectors",
    "MathML",
    //"Media Queries",
    //"Microsoft Extensions",
    //"Mozilla Extensions",
    //"Pointer Events",
    //"Pseudo",
    //"Pseudo-classes",
    //"Pseudo-elements",
    //"Selectors",
    //"WebKit Extensions"
];


/*
export const ALL_STYLES = [
    "align-content", "align-items", "align-self", "all", "animation", "animation-delay", "animation-direction", "animation-duration", "animation-fill-mode", "animation-iteration-count", "animation-name", "animation-play-state", "animation-timing-function", "backface-visibility", "background", "background-attachment", "background-blend-mode", "background-clip", "background-color", "background-image", "background-origin", "background-position", "background-repeat", "background-size", "border", "border-bottom", "border-bottom-color", "border-bottom-left-radius", "border-bottom-right-radius", "border-bottom-style", "border-bottom-width", "border-collapse", "border-color", "border-image", "border-image-outset", "border-image-repeat", "border-image-slice", "border-image-source", "border-image-width", "border-left", "border-left-color", "border-left-style", "border-left-width", "border-radius", "border-right", "border-right-color", "border-right-style", "border-right-width", "border-spacing", "border-style", "border-top", "border-top-color", "border-top-left-radius", "border-top-right-radius", "border-top-style", "border-top-width", "border-width", "bottom", "box-shadow", "box-sizing", "caption-side", "clear", "clip", "color", "column-count", "column-fill", "column-gap", "column-rule", "column-rule-color", "column-rule-style", "column-rule-width", "column-span", "column-width", "columns", "content", "counter-increment", "counter-reset", "cursor", "direction", "display", "empty-cells", "filter", "flex", "flex-basis", "flex-direction", "flex-flow", "flex-grow", "flex-shrink", "flex-wrap", "float", "font", "@font-face", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "hanging-punctuation", "height", "justify-content", "@keyframes", "left", "letter-spacing", "line-height", "list-style", "list-style-image", "list-style-position", "list-style-type", "margin", "margin-bottom", "margin-left", "margin-right", "margin-top", "max-height", "max-width", "@media", "min-height", "min-width", "nav-down", "nav-index", "nav-left", "nav-right", "nav-up", "opacity", "order", "outline", "outline-color", "outline-offset", "outline-style", "outline-width", "overflow", "overflow-x", "overflow-y", "padding", "padding-bottom", "padding-left", "padding-right", "padding-top", "page-break-after", "page-break-before", "page-break-inside", "perspective", "perspective-origin", "position", "quotes", "resize", "right", "tab-size", "table-layout", "text-align", "text-align-last", "text-decoration", "text-decoration-color", "text-decoration-line", "text-decoration-style", "text-indent", "text-justify", "text-overflow", "text-shadow", "text-transform", "top", "transform", "transform-origin", "transform-style", "transition", "transition-delay", "transition-duration", "transition-property", "transition-timing-function", "unicode-bidi", "vertical-align", "visibility", "white-space", "width", "word-break", "word-spacing", "word-wrap", "z-index"
];



export const ALL_STYLES = [
    "accentColor",
    "alignContent",
    "alignItems",
    "alignSelf",
    "alignTracks",
    "animationDelay",
    "animationDirection",
    "animationDuration",
    "animationFillMode",
    "animationIterationCount",
    "animationName",
    "animationPlayState",
    "animationTimeLine",
    "animationTimingFunction",
    "appearance",
    "aspectRatio",
    "backdropFilter",
    "backfaceVisibility",
    "backgroundAttachment",
    "backgroundBlendMode",
    "backgroundClip",
    "backgroundColor",
    "borderBottomColor",
    "borderBottomLeftRadius",
    "borderBottomRightRadius",
    "borderBottomWidth",
    "borderColor",
    "borderLeftColor",
    "borderLeftWidth",
    "borderRadius",
    "borderRightColor",
    "borderRightWidth",
    "borderStyle",
    "borderTopColor",
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderTopWidth",
    "borderWidth",
    "bottom",
    "color",
    "decomposedMatrix",
    "direction",
    "display",
    "elevation",
    "flex",
    "flexBasis",
    "flexDirection",
    "flexGrow",
    "flexShrink",
    "flexWrap",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "height",
    "includeFontPadding",
    "justifyContent",
    "left",
    "letterSpacing",
    "lineHeight",
    "margin",
    "marginBottom",
    "marginHorizontal",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginVertical",
    "maxHeight",
    "maxWidth",
    "minHeight",
    "minWidth",
    "opacity",
    "overflow",
    "overlayColor",
    "padding",
    "paddingBottom",
    "paddingHorizontal",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "paddingVertical",
    "position",
    "resizeMode",
    "right",
    "rotation",
    "scaleX",
    "scaleY",
    "shadowColor",
    "shadowOffset",
    "shadowOpacity",
    "shadowRadius",
    "textAlign",
    "textAlignVertical",
    "textDecorationColor",
    "textDecorationLine",
    "textDecorationStyle",
    "textShadowColor",
    "textShadowOffset",
    "textShadowRadius",
    "tintColor",
    "top",
    "transform",
    "transformMatrix",
    "translateX",
    "translateY",
    "width",
    "writingDirection",
    "zIndex"
];
*/
